import { capitalizeEachWord } from "~/utils/strings";
import { UsTerritories } from "../../CaseDetailsDrawer/Profiles/common/AddressFields/StateFormField/constants";

const findTerritory = (input: string | undefined | null) => {
  if (!input) return undefined;

  const normalized = input.trim().toUpperCase();

  return (
    UsTerritories.find((t) => t.code === normalized) ??
    UsTerritories.find((t) => t.name === normalized)
  );
};

export const findUsStateMatch = (
  extractedState: string | undefined | null,
): string | undefined => findTerritory(extractedState)?.code;

export const findUsStateName = (
  extractedState: string | undefined | null,
): string | undefined => {
  const territory = findTerritory(extractedState);
  return territory ? capitalizeEachWord(territory.name) : undefined;
};
